import BodyText from "./BodyText";
import Box from "./Box";
import HeadingMain from "./HeadingMain";
import SingleColumnLayout from "./SingleColumnLayout";
import TakebackForm from "./TakebackForm";
import TakebackRules from "./TakebackRules";
import { useTakebackConfig } from "./TakebackConfigContext";

function Choose() {
  const { takebackDescription, chooseItemsHeadingOverride } =
    useTakebackConfig();

  return (
    <SingleColumnLayout>
      <Box px={[null, null, null, "7.75vw"]}>
        <HeadingMain pb={35}>
          {chooseItemsHeadingOverride || "Choose the items you're trading in"}
        </HeadingMain>
        <BodyText pb={40}>{takebackDescription}</BodyText>
        <TakebackRules />
        <TakebackForm />
      </Box>
    </SingleColumnLayout>
  );
}

export default Choose;
